module.exports = "/_next/static/images/logo-c12f9247346f5159a65bb8d298994a4e.png";